import { StreemApiUserAvailabilityAvailabilityStatus } from '@streem/api';
import { streem } from 'streem-sdk-protobuf';

const AvailabilityStatus = streem.api.AvailabilityStatus;

export function mapApiStatusToWallStatus(
    apiStatus: StreemApiUserAvailabilityAvailabilityStatus,
): streem.api.AvailabilityStatus {
    return AvailabilityStatus[apiStatus];
}

const availabilityStatusToApiStatusMap: {
    [key in streem.api.AvailabilityStatus]: StreemApiUserAvailabilityAvailabilityStatus;
} = {
    [AvailabilityStatus.AVAILABILITY_STATUS_INVALID]:
        StreemApiUserAvailabilityAvailabilityStatus.INVALID,
    [AvailabilityStatus.AVAILABILITY_STATUS_AVAILABLE]:
        StreemApiUserAvailabilityAvailabilityStatus.AVAILABLE,
    [AvailabilityStatus.AVAILABILITY_STATUS_NOT_AVAILABLE]:
        StreemApiUserAvailabilityAvailabilityStatus.NOTAVAILABLE,
    [AvailabilityStatus.AVAILABILITY_STATUS_RESERVED]:
        StreemApiUserAvailabilityAvailabilityStatus.RESERVED,
    [AvailabilityStatus.AVAILABILITY_STATUS_IN_CALL]:
        StreemApiUserAvailabilityAvailabilityStatus.INCALL,
    [AvailabilityStatus.AVAILABILITY_STATUS_CONFIRMING]:
        StreemApiUserAvailabilityAvailabilityStatus.CONFIRMING,
    [AvailabilityStatus.AVAILABILITY_STATUS_OFFLINE]:
        StreemApiUserAvailabilityAvailabilityStatus.OFFLINE,
};

export function mapWallStatusToApiStatus(
    status: streem.api.AvailabilityStatus,
): StreemApiUserAvailabilityAvailabilityStatus {
    return availabilityStatusToApiStatusMap[status];
}
